"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResumeWatchingStorageRepository = void 0;
var tslib_1 = require("tslib");
var firestoreResumeWatchingManager_1 = require("./firestoreResumeWatchingManager");
var ResumeWatchingStorageRepository = /** @class */ (function () {
    function ResumeWatchingStorageRepository() {
        this.resumeWatchingManager = new firestoreResumeWatchingManager_1.FirestoreResumeWatchingManager();
    }
    ResumeWatchingStorageRepository.prototype.add = function (userId, item, profileId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.resumeWatchingManager.add(userId, item, profileId)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ResumeWatchingStorageRepository.prototype.remove = function (userId, itemId, profileId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.resumeWatchingManager.remove(userId, itemId, profileId)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ResumeWatchingStorageRepository.prototype.getItem = function (userId, itemId, profileId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.resumeWatchingManager.getItem(userId, itemId, profileId)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ResumeWatchingStorageRepository.prototype.getItems = function (userId, profileId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.resumeWatchingManager.getItems(userId, profileId)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ResumeWatchingStorageRepository.prototype.getLastWatchedEpisode = function (userId, seriesId, profileId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.resumeWatchingManager.getLastWatchedEpisode(userId, seriesId, profileId)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ResumeWatchingStorageRepository.prototype.isItemInWatchingProgress = function (userId, itemId, resourceType, profileId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.resumeWatchingManager.isItemInWatchingProgress(userId, itemId, resourceType, profileId)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return ResumeWatchingStorageRepository;
}());
exports.ResumeWatchingStorageRepository = ResumeWatchingStorageRepository;
